import { cloneDeep } from "lodash";
import { FieldName, FieldSchema, Schema } from "../Schema";
import { BasicState, CustomState, FieldsState } from "./DynamicManager";

export abstract class StaticManager<S extends BasicState, C extends CustomState = CustomState> {
  protected schema: Schema;
  state: FieldsState<S> = {};
  abstract customState: C;

  constructor(schema: Schema) {
    this.schema = cloneDeep(schema);
    for (const fieldName in schema) {
      this.state[fieldName] = {
        loading: false,
        ...this.getMapping(schema[fieldName]),
      } as S;
    }
  }

  abstract getMapping(field: FieldSchema): Omit<S, keyof BasicState>;
  abstract updateCustomState(): void;

  getFieldState(name: FieldName): S {
    return cloneDeep(this.state[name]);
  }

  getState(): FieldsState<S> {
    return cloneDeep(this.state);
  }

  getCustomState(): C {
    return cloneDeep(this.customState);
  }
}
